<script setup lang="ts">
import PlanTag from '@/atoms/PlanTag.vue'
import { TEAM_PLAN_PRICE } from '@WombatTechnology/nitte-time-lib'
</script>

<template>
  <strong-g class="pd-rect lo-v">
    <PlanTag :type="'team'"> チーム </PlanTag>
    <main-title class="lo-h-baseline">
      {{ TEAM_PLAN_PRICE }}円<description>/人・月(税込)</description>
    </main-title>
  </strong-g>
</template>
